import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

let router = new Router({
	routes: [
		{
			path: '/',
			name: 'MainPage',
			component: () => import('@/components/Index')
		},
	],
	mode: 'history'
})

export default router



// WEBPACK FOOTER //
// ./src/router.js